export default __webpack_public_path__ + "static/background-collection.url-124838d294995cd39aace9eedc7bcda8.svg";